import React, { useContext } from 'react'
import { TextField } from '@mui/material'
import { useFormContext, Controller } from 'react-hook-form'
import { WhatsappDataContext } from '../WhatsappMessageContent';

const TextContent = () => {
  const {initialWhatsappData} = useContext(WhatsappDataContext);
  const { control } = useFormContext();
  return (
    <>
        <Controller
          name="message"
          control={control}
          rules={{ required: 'Message text is required', minLength: { value: 1, message: 'Enter message' } }}
          render={({ field, fieldState: { error } }) => (
              <TextField
                  {...field}
                  label="Message Text"
                  fullWidth
                  multiline
                  minRows={4}
                  size="small"
                  error={!!error}
                  helperText={error?.message}
                  InputProps={{ style: { fontSize: '0.8rem' } }}
                  InputLabelProps={{ style: { fontSize: '0.8rem' } }}
              />
          )}
      />
      
    </>
  )
}

export default TextContent
